export default __webpack_public_path__ + "static/NunitoSans-a3c0f35e8242817e249e0db7018f7003.woff2";